import PropTypes from 'prop-types'
import LazyLoad from 'react-lazyload'
import { Badge } from '@leroy-merlin-br/backyard-react-ui'

import ShapeThumb from 'reactGarden/common/prop-types/ThumbContent'

import { ThumbFlags } from '../ThumbFlags'
import * as S from './styled'

const ThumbPicture = ({ data, children }) => (
  <S.ThumbnailPicture>
    <S.PatternGradient />

    <LazyLoad offset={200} once>
      <figure>
        <img
          src={ data.background_image }
          alt={ data.title }
          title={ data.title }
        />
      </figure>
    </LazyLoad>

    <S.BadgeWrapper>
      <Badge color="green" isLight>
        Inspire-se
      </Badge>
    </S.BadgeWrapper>

    { children }
    <ThumbFlags data={ data } />
  </S.ThumbnailPicture>
)

ThumbPicture.propTypes = {
  data: PropTypes.shape({ ...ShapeThumb }).isRequired
}

export default ThumbPicture
